export * from "./SuperBannerData";